export default "__VITE_ASSET__$pWhEWPF__"